<template>
  <div class="h-full">
    <div class="flex lg:flex-row flex-col mb-4 text-right">
      <div class="flex flex-row">
        <BaseInput
          :value="companySearch"
          placeholder="Sök"
          class="w-64"
          @input="debounceSearch"
        />
        <div class="ml-4 mr-3">
          <button class="btn btn-primary" @click="create">Nytt företag</button>
        </div>
      </div>
      <div class="flex-1">
        <div class="flex flex-row gap-x-2">
          <div
            v-for="filter of filters"
            :key="filter.value"
            class="flex flex-row items-center py-2 space-x-2"
          >
            <input
              :id="filter.label"
              v-model="selectedFilter"
              type="radio"
              :value="filter.value"
            />
            <label :for="filter.label">{{ filter.label }}</label>
          </div>
        </div>
        <div class="flex flex-row gap-x-2">
          <div
            v-for="filter of subfilters"
            :key="filter.value"
            class="flex flex-row items-center py-2 space-x-2"
          >
            <input
              :id="filter.label"
              v-model="selectedSubFilters"
              type="checkbox"
              :value="filter.value"
            />
            <label :for="filter.label">{{ filter.label }}</label>
          </div>
        </div>
      </div>
      <div class="inline-flex justify-end">
        <div>
          <span
            class="bg-lagon-100 text-lagon-500 px-2 py-1 text-sm font-semibold rounded-full"
          >
            {{ companies.length }} st
          </span>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loading" class="w-full pt-16 text-center">
      <b-spinner class="align-middle" />
    </div>

    <!-- Error -->

    <!-- Result -->
    <div v-else-if="companies.length" class="result apollo">
      <b-table
        hover
        striped
        :fields="fields"
        :items="companies"
        sort-icon-left
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        sort-null-last
        @row-clicked="details"
      >
        <template #cell(displayname)="data">
          <span v-if="data.item.displayname">{{ data.item.displayname }}</span>
          <span v-else>{{ data.item.name }}</span>
        </template>
      </b-table>
    </div>

    <div v-else-if="error" class="error apollo">Ett fel inträffade</div>
    <!-- No result -->
    <div v-else class="no-result apollo">Inga företag hittades :(</div>
    <CreateCompany />
  </div>
</template>

<script>
import CreateCompany from './CreateCompany.vue'
import { useCompanies } from '../../composables/use-companies'
import { mapState } from 'vuex'
export default {
  components: { CreateCompany },
  setup() {
    const {
      companies,
      loading,
      error,
      search,
      filters,
      selectedFilter,
      subfilters,
      selectedSubFilters,
    } = useCompanies()
    return {
      companies,
      loading,
      error,
      search,
      selectedFilter,
      subfilters,
      selectedSubFilters,
      filters,
    }
  },
  data() {
    return {
      debounce: null,

      fields: [
        {
          key: 'displayname',
          label: 'Visningsnamn',
          sortable: true,
        },
        {
          key: 'companyNumber',
          label: 'Företagsnummer',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Namn',
          sortable: true,
        },
        {
          key: 'actions',
          label: '',
          sortable: false,
        },
      ],
      sortBy: 'displayname',
      sortDesc: false,
      sortDirection: 'asc',
    }
  },
  computed: {
    ...mapState('companies', {
      companySearch: state => state.companySearch,
    }),
  },
  methods: {
    debounceSearch(val) {
      this.$store.commit('companies/updateCompanySearch', val)
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.search = val
      }, 600)
    },
    details(row) {
      this.$router.push({ name: 'companydetails', params: { id: row.id } })
    },
    create() {
      this.$modal.show('create-company')
    },
  },
  mounted() {
    this.search = this.companySearch
  },
}
</script>
